import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TSalesProcessingApi } from './types';

export const salesProcessing: TSalesProcessingApi = {
	getUploadedFiles: (payload) =>
		http.post(endpoint.salesProcessing.UPLOADED_FILES, payload).then((response) => response.data),
	getProcessingTypes: () =>
		http.get(endpoint.salesProcessing.PROCESSING_TYPES).then((response) => response.data),
	processFile: (payload) =>
		http
			.post(endpoint.salesProcessing.PROCESS_FILE, payload.body, {
				params: {
					id: payload.id,
				},
			})
			.then((response) => response.data),
	downloadFile: (fileId) =>
		http
			.post(endpoint.salesProcessing.DOWNLOAD_FILE(fileId), null, {
				responseType: 'blob',
			})
			.then((response) => response.data),
	getFileStatuses: () =>
		http.get(endpoint.salesProcessing.FILE_STATUSES).then((response) => response.data),
	getEmInvoicingFeeTypes: () =>
		http.get(endpoint.salesProcessing.INVOICING_FEE_TYPES).then((response) => response.data),
};
